import {
  RESET_AUTO_CAMPS,
  SET_TEMP_AUTO_CAMPAIGN,
  SET_AUTO_CAMPAIGN_TEMPLATE,
  SET_AUTO_CAMPAIGN_TEMPLATES,
  SET_AUTO_DRAFTED_CAMP_STATE,
  SET_AUTO_CAMP_SHORTLINK,
  RESET_AUTO_DRAFTED_CAMP_STATE,
  SET_AUTO_CAMP_DETAIL,
  SET_AUTO_CAMPAIGN_OVERVIEW,
  SET_AUTO_CAMPAIGNS_CUSTOMERS_LIST,
  SET_ACTIVE_AUTO_CAMP_IDS,
  SET_AUTO_CAMPAIGN_DRAFTS,
  INIT_AUTO_DRAFTED_CAMP_STATE,
} from "../types";

const initialState = {
  templates: [],
  draftTemplates: {},
  currTemplate: {},
  draftedCampState: {},
  tempState: {},
  shortlink: "",
  overview: {},
  campDetail: {},
  campCustomers: {},
  activeAutoCampIds: [],
};

const autoEngageReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TEMP_AUTO_CAMPAIGN:
      return {
        ...state,
        tempState: { ...state.tempState, ...action.payload },
      };
    case SET_AUTO_CAMPAIGN_TEMPLATES:
      return {
        ...state,
        templates: action.payload,
      };
    case SET_AUTO_CAMPAIGN_DRAFTS:
      return {
        ...state,
        draftTemplates: action.payload,
      };
    case SET_AUTO_CAMP_SHORTLINK:
      return {
        ...state,
        shortlink: action.payload,
      };
    case SET_ACTIVE_AUTO_CAMP_IDS:
      return {
        ...state,
        activeAutoCampIds: action.payload,
      };
    case SET_AUTO_CAMPAIGN_TEMPLATE:
      return {
        ...state,
        currTemplate: action.payload,
      };
    case SET_AUTO_DRAFTED_CAMP_STATE:
      return {
        ...state,
        draftedCampState: { ...state.draftedCampState, ...action.payload },
      };
    case INIT_AUTO_DRAFTED_CAMP_STATE:
      return {
        ...state,
        draftedCampState: action.payload,
      };
    case SET_AUTO_CAMP_DETAIL:
      return {
        ...state,
        campDetail: action.payload,
      };
    case SET_AUTO_CAMPAIGN_OVERVIEW:
      return {
        ...state,
        overview: action.payload,
      };
    case SET_AUTO_CAMPAIGNS_CUSTOMERS_LIST:
      return {
        ...state,
        campCustomers: action.payload,
      };
    case RESET_AUTO_DRAFTED_CAMP_STATE:
      return {
        ...state,
        draftedCampState: {},
      };
    case RESET_AUTO_CAMPS:
      return initialState;
    default:
      return state;
  }
};

export default autoEngageReducer;
